import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { slugify } from '../../utils/utils';
import { useNearScreen } from '../../hooks/useNearScreen';
import { Card, Title, ImgWrapper, CardWrapper } from './styles';
import { Img } from '../Img';

function ItemCard({ programa, style, area, loading }) {
  const { isNearScreen, elementRef } = useNearScreen();
  const [imageIsReady, setImageIsReady] = useState(false);

  const fillContent = () => {
    return (
      <Card isLoading={imageIsReady ? 'false' : 'true'}>
        <Link to={`/area/${area.slug}/programa/${slugify(programa.pregrado)}`}>
          <ImgWrapper>
            <Img
              className="ItemCard__img"
              src={programa.urlCaption}
              alt={programa.pregrado}
              onLoad={setImageIsReady}
            />
          </ImgWrapper>
          <Title isLoading={!imageIsReady}>{programa.pregrado}</Title>
        </Link>
      </Card>
    );
  };

  const verifyLoading = () => {
    if (loading) {
      return fillPreload();
    }
    return fillContent();
  };

  const fillPreload = () => {
    return <Card isLoading={'true'}></Card>;
  };

  return (
    <CardWrapper className={`${style}`} ref={elementRef}>
      {isNearScreen && verifyLoading()}
    </CardWrapper>
  );
}

export default ItemCard;
